import React, { useState } from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import {
    Business,
    LocationOn,
    Smartphone,
    Email,
    AccessTime,
    Handshake,
} from "@mui/icons-material";

function ContactPage() {
    const [formData, setFormData] = useState({
        companyName: "",
        fullName: "",
        email: "",
        phone: "",
        yachtCount: "",
        message: "",
        type: "partner", // partner veya contact
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        // Form gönderme işlemi burada yapılacak
        console.log(formData);
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    return (
        <div className="min-h-screen relative">
            {/* Background Image */}
            <div
                className="fixed inset-0 bg-cover bg-center bg-no-repeat"
                style={{
                    backgroundImage: `url(/images/yacht-bg-3.jpg)`,
                    filter: "brightness(0.9) saturate(1.2)",
                }}
            />

            {/* Gradient Overlay */}
            <div className="fixed inset-0 bg-gradient-to-b from-gray-900/90 via-gray-900/70 to-gray-900/90" />

            {/* Content */}
            <div className="relative z-10">
                <Navbar />

                {/* Hero Section */}
                <div className="relative pt-36 pb-12 text-center text-white">
                    <h1 className="text-5xl font-bold mb-4">İletişim</h1>
                    <p className="text-lg text-white/60">
                        Bizimle iletişime geçin veya iş ortağımız olun
                    </p>
                </div>

                {/* Content */}
                <div className="max-w-7xl mx-auto px-4 py-12 mb-18">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
                        {/* Contact Info Card */}
                        <div className="lg:col-span-1 space-y-8">
                            {/* Office Info */}
                            <div className="bg-white/5 backdrop-blur-md rounded-3xl p-8 border border-white/10">
                                <div className="flex items-center mb-6">
                                    <Business
                                        className="text-4xl mr-4 text-blue-400"
                                        sx={{ fontSize: 40 }}
                                    />
                                    <h2 className="text-2xl font-bold text-white">
                                        Ofisimiz
                                    </h2>
                                </div>
                                <div className="space-y-4 text-white/70">
                                    <p className="flex items-center">
                                        <LocationOn
                                            className="text-xl mr-3 text-blue-400"
                                            sx={{ fontSize: 24 }}
                                        />
                                        Girne Marina, Kuzey Kıbrıs
                                    </p>
                                    <p className="flex items-center">
                                        <Smartphone
                                            className="text-xl mr-3 text-blue-500"
                                            sx={{ fontSize: 24 }}
                                        />
                                        +90 533 123 4567
                                    </p>
                                    <p className="flex items-center">
                                        <Email
                                            className="text-xl mr-3 text-blue-300"
                                            sx={{ fontSize: 24 }}
                                        />
                                        info@cyprusyacht.com
                                    </p>
                                </div>
                            </div>

                            {/* Working Hours */}
                            <div className="bg-white/5 backdrop-blur-md rounded-3xl p-8 border border-white/10">
                                <div className="flex items-center mb-6">
                                    <AccessTime
                                        className="text-4xl mr-4 text-blue-400"
                                        sx={{ fontSize: 40 }}
                                    />
                                    <h2 className="text-2xl font-bold text-white">
                                        Çalışma Saatleri
                                    </h2>
                                </div>
                                <div className="space-y-4 text-white/70">
                                    <p>Pazartesi - Cumartesi</p>
                                    <p className="text-xl font-semibold text-white">
                                        09:00 - 18:00
                                    </p>
                                    <p className="mt-4">Pazar</p>
                                    <p className="text-xl font-semibold text-white">
                                        10:00 - 16:00
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Form */}
                        <div className="lg:col-span-2">
                            <div className="bg-white/5 backdrop-blur-md rounded-3xl p-8 border border-white/10">
                                <div className="flex items-center mb-8">
                                    <Handshake
                                        className="text-4xl mr-4 text-blue-500"
                                        sx={{ fontSize: 40 }}
                                    />
                                    <h2 className="text-2xl font-bold text-white">
                                        İş Ortağımız Olun
                                    </h2>
                                </div>
                                <form
                                    onSubmit={handleSubmit}
                                    className="space-y-6"
                                >
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div>
                                            <label className="block text-white/80 mb-2">
                                                Şirket Adı
                                            </label>
                                            <input
                                                type="text"
                                                name="companyName"
                                                value={formData.companyName}
                                                onChange={handleChange}
                                                className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-white/30 focus:outline-none focus:border-blue-500 transition-all duration-300"
                                                placeholder="Şirketinizin adı"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-white/80 mb-2">
                                                Ad Soyad
                                            </label>
                                            <input
                                                type="text"
                                                name="fullName"
                                                value={formData.fullName}
                                                onChange={handleChange}
                                                className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-white/30 focus:outline-none focus:border-blue-500 transition-all duration-300"
                                                placeholder="Adınız ve soyadınız"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-white/80 mb-2">
                                                E-posta
                                            </label>
                                            <input
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-white/30 focus:outline-none focus:border-blue-500 transition-all duration-300"
                                                placeholder="E-posta adresiniz"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-white/80 mb-2">
                                                Telefon
                                            </label>
                                            <input
                                                type="tel"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-white/30 focus:outline-none focus:border-blue-500 transition-all duration-300"
                                                placeholder="Telefon numaranız"
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <label className="block text-white/80 mb-2">
                                            Yat Sayısı
                                        </label>
                                        <input
                                            type="number"
                                            name="yachtCount"
                                            value={formData.yachtCount}
                                            onChange={handleChange}
                                            className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-white/30 focus:outline-none focus:border-blue-500 transition-all duration-300"
                                            placeholder="Kaç yatınız var?"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-white/80 mb-2">
                                            Mesajınız
                                        </label>
                                        <textarea
                                            name="message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            rows="4"
                                            className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-white/30 focus:outline-none focus:border-blue-500 transition-all duration-300 resize-none"
                                            placeholder="Mesajınız..."
                                        ></textarea>
                                    </div>
                                    <button
                                        type="submit"
                                        className="w-full py-4 px-6 bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-xl hover:shadow-lg hover:shadow-blue-500/30 transition-all duration-300 transform hover:-translate-y-0.5 text-lg font-semibold"
                                    >
                                        Başvuruyu Gönder
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    );
}

export default ContactPage;
